var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMktTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25C31.5 25.67 31.5 26.33 31.5 27C32.7 27 34.26 27 35.5 27C35.5 26.33 35.5 25.67 35.5 25C34.26 25 32.7 25 31.5 25Z",
    fill: "#1565D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 31.61C30.46 32.32 31.71 33.26 32.7 34C33.1 33.47 33.5 32.93 33.9 32.4C32.91 31.66 31.66 30.72 30.7 30C30.3 30.54 29.9 31.08 29.5 31.61Z",
    fill: "#1565D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 19.6C33.5 19.07 33.1 18.53 32.7 18C31.71 18.74 30.46 19.68 29.5 20.4C29.9 20.93 30.3 21.47 30.7 22C31.66 21.28 32.91 20.35 33.9 19.6Z",
    fill: "#1565D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23C16.4 23 15.5 23.9 15.5 25V27C15.5 28.1 16.4 29 17.5 29H18.5V33H20.5V29H21.5L26.5 32V20L21.5 23H17.5ZM22.53 24.71L24.5 23.53V28.47L22.53 27.29L22.05 27H21.5H17.5V25H21.5H22.05L22.53 24.71Z",
    fill: "#1565D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26C29 24.67 28.42 23.47 27.5 22.65V29.34C28.42 28.53 29 27.33 29 26Z",
    fill: "#1565D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.53 24.71L24.5 23.53V28.47L22.53 27.29L22.05 27H21.5H17.5V25H21.5H22.05L22.53 24.71Z",
    fill: "#1565D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 38L50 -8.74228e-08L52 0L52 38C51.5 38.5 51.5 38.5 51.5 38.5C51.5 38.5 50.3905 38 50 38Z",
    fill: "#1565D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.641 38.3781L39.4493 51.1986C39.098 51.4952 38.4999 51.9999 38.4999 51.9999C38.4999 51.9999 37.6079 50.5577 37.5 50.0001L50.1917 36.9999L51.641 38.3781Z",
    fill: "#1565D8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37115e-8,
    x2: 0.999998,
    y2: 52,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 1,
    y2: 1,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 51L2 51",
    stroke: "#1565D8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMktTeam);
export default __webpack_public_path__ + "static/media/mkt-team.bcc51c02af4657f5281f689fcbae944b.svg";
export { ForwardRef as ReactComponent };